/*
import DeXParaRepository from "@/repositories/dexpara/ResultRangeRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'resultrange',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listAll({commit}, params) {            
            commit('setLoading', true)
            await DeXParaRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                commit('setPagination', response.data)
            })
            commit('setLoading', false)
        },
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await DeXParaRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.mappingResultRange)
            })
            commit('setLoading', false)
        }
    }
}
*/

import ResultRangeRepository from "@/repositories/dexpara/ResultRangeRepository";
import makeStore from "@/storages/Base/Storage";

const store = makeStore('resultrange', ResultRangeRepository);

export default {
    ...store
};